import { render, staticRenderFns } from "./user-management-skeleton.vue?vue&type=template&id=520268d9"
import script from "./user-management-skeleton.vue?vue&type=script&lang=js"
export * from "./user-management-skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports